module.exports = __webpack_public_path__ + "img/AnnotatedLootRoller.5af69521.jpg";